import React, { useState, useEffect } from "react";
import { postData } from "../common/utils";
import { decorator } from "../common/decorator";
import { useHistory } from "react-router";
import { NavLink } from "react-router-dom";
import { encryptData } from "./../../utils/functions";

//Draftjs
import { EditorState, convertFromRaw } from "draft-js";
import "draft-js/dist/Draft.css";

//Draftjs - plugins
import Editor from "@draft-js-plugins/editor";

//popupjs - plugins
import Popup from "reactjs-popup";
import "./popupplug.css";

import "./comments.css";
//Images
import profile from "../../assets/images/profile.jpg";
import ellipsis from "../../assets/images/ellipsis.png";
import edit from "../../assets/images/edit.png";
import deletebtn from "../../assets/images/delete.png";

import bdg_teamplayer from "../../assets/images/bdg_teamplayer.png";
import bdg_innovator from "../../assets/images/bdg_innovator.png";
import like_blue2 from "../../assets/images/like_blue2.png";
import like_grey from "../../assets/images/like.png";
import comment from "../../assets/images/comment.png";
import arrowLeft from "../../assets/images/arrow_left.png";
import arrowRight from "../../assets/images/arrow_right.png";
import arrowTop from "../../assets/images/arrow_top.png";
import arrowBottom from "../../assets/images/arrow_bottom.png";
import cancel from "../../assets/images/cancel.png";
import DeleteComment from "./deletecomment_btn";
import LikeComment from "./LikeCommentbtn";

//Emoji
import createEmojiPlugin from '@draft-js-plugins/emoji';
import '@draft-js-plugins/emoji/lib/plugin.css';

//Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import { useAlert } from "react-alert";
import OutsideClickHandler from 'react-outside-click-handler';

//import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import "emoji-mart/css/emoji-mart.css";
import Comment from "./comment";
import PostLike from "./LikePost";
import EmojiComment from "./EmojiComment";
import $ from 'jquery';
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';


const PostItem = (props) => {

  //console.log("propppps----------------------------------------------------------", props);
  const history = useHistory();
  const [disable, setDisable] = React.useState(false);
  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );

  const emojiPlugin = createEmojiPlugin({
    // useNativeArt: true,
  });

  const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
  const plugins = [emojiPlugin];

  useEffect(() => {

    delete_user_check();

    if (props.data.postJSON !== "" && props.data.postJSON !== null) {
      setEditorState(
        EditorState.createWithContent(
          convertFromRaw(JSON.parse(props.data.postJSON)),
          decorator
        )
      );
      //setEditorState(EditorState.push(editorState,convertFromRaw(JSON.parse(props.data.postJSON))));
    }

  }, []);




  // const [postLike, setPostLike] = useState(props.data.userLike);
  // const [postLikesQuantity, setPostLikesQuantity] = useState(props.data.LikesQuantity);
  // const [allPostLikes, setAllPostLikes] = useState(props.data.likes);
  const alert = useAlert();
  const [comments, setComments] = useState("");
  //const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
  const [commentsQuantity, setCommentsQuantity] = useState(
    props.data.CommentsQuantity
  );
  const [allComments, setAllComments] = useState(props.data.comments);
  const [isViewAllOpen, setIsViewAllOpen] = useState(false);
  const [dropDown, setDropdown] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  // function togglePostLike() {
  //   console.log("Post toggle like");
  //   var likeFlag = !postLike;
  //   postData(process.env.REACT_APP_API_URL + "api/posts/like", {
  //     postID: props.data.postID,
  //     likeFlag: likeFlag,
  //   }).then((data) => {
  //     if (data.issuccessful == true) {
  //       setPostLike(!postLike);
  //       if (likeFlag) {
  //         setPostLikesQuantity(postLikesQuantity + 1);
  //       } else {
  //         setPostLikesQuantity(postLikesQuantity - 1);
  //       }
  //       //console.log(data.likes);
  //       setAllPostLikes(data.likes);
  //     } else {
  //       console.log(data.message);
  //     }
  //   });
  // }





  //#region badgesSlider
  const BadgesSlider = () => {
    var showBadges = false;
    var badges = props.data.badges;
    var badgesWithImage = badges.filter((badge, index) => {
      return badge.badgeImage !== null && badge.badgeImage !== "";
    });
    if (badgesWithImage.length > 0) {
      showBadges = true;
    }

    if (showBadges) {
      return (
        <div className="pp-slider-wrap">
          <Swiper
            slidesPerView={4}
            spaceBetween={5}
            navigation={
              (true,
              {
                nextEl: ".pp-next-" + props.data.postID,
                prevEl: ".pp-prev-" + props.data.postID,
              })
            }
            className="pp-slider"
          >
            {badgesWithImage.map((badge, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="pp-badge-item">
                    <img
                      src={
                        process.env.REACT_APP_API_URL +
                        "api/images/badges/" +
                        badge.badgeImage
                      }
                      style={{ width: "110px", height: "110px" }}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <img
            src={arrowRight}
            className={"pp-arrow pp-next pp-next-" + props.data.postID}
            alt="next"
          />
          <img
            src={arrowLeft}
            className={"pp-arrow pp-prev pp-prev-" + props.data.postID}
            alt="prev"
          />
        </div>
      );
    } else {
      return <div className="pp-slider-wrap"></div>;
    }
  };

  //#endregion


  //#region comment submit
  const commentSubmit = (e) => {
    e.preventDefault();
    //Bug was === and ! together didnt work properly
    if (comments !== "") {
      postData(process.env.REACT_APP_API_URL + "api/posts/comment", {
        postID: props.data.postID,
        commentText: comments,
      }).then((data) => {
        if (data.issuccessful == true) {
          setComments("");
          setAllComments(data.comments);
        } else {
          console.log(data.message);
        }
      });
    }
  };
  //  const [show, setShow] = useState(false);

  const addEmoji = (e) => {
    let sym = e.unified.split("-");
    let codesArray = [];
    sym.forEach((el) => codesArray.push("0x" + el));
    let emoji = String.fromCodePoint(...codesArray);
    setComments(comments + emoji);
  };

  //#endregion

  //#region comment display
  const CommentView = (props) => {
    var comuid;
    return (
      <div className="comment-view">
        {props.data.map((comment, index) => {
          //console.log("--- comment --- ", comment);

          return (
            <>
              <div className="comment-content" key={index}>
                <div className="comment-profile">
                  <img
                    className="pop-img"
                    src={
                      process.env.REACT_APP_IMG_URL +
                      (comment.userImage ? comment.userImage : "no-img.png")
                    }
                    alt=""
                  />
                </div>
                <div className="comment-text">
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <NavLink
                      activeclassName="pp-profile-name-nav"
                      style={{ textDecoration: "none", color: "black" }}
                      to={"/profile/" + comment.userID}
                    >
                      <p id="comment-name">{comment.userName}</p>
                    </NavLink>
                    <DeleteComment data={comment} />
                  </div>
                  <p>{comment.commentText}</p>
                </div>

              </div>
              <LikeComment data={comment} postID={props.postID} />
            </>

          );

        })}
        <div
          className="comment-view-more"
          style={
            commentsQuantity > 2 && !isViewAllOpen
              ? { display: "block" }
              : { display: "none" }
          }
        > <span onClick={getAllComments}>View all comments</span>
        </div>

      </div>
    );
  };

  const getAllComments = () => {

    fetch(
      process.env.REACT_APP_API_URL + "api/post-comments/" + props.data.postID
    )
      .then((response) => response.json())
      .then((data) => {
        setAllComments(data);

        setIsViewAllOpen(true);
      });
    //console.log(response,"...........RESPONSE..........");
  };
  function refreshPage(data) {
    alert.success(data.message);
    setTimeout(() => {
      window.location.reload(false);

    }, 1000)

  }

  const delete_user_check = () => {

    var data = {

      UserID: props.data.UserID,
      postID: props.data.postID,
    };
    postData(
      process.env.REACT_APP_API_URL + "api/post/deletecheck",
      data
    )
      .then((data) => {
        if (data.issuccessful == true) {
          //window.location.reload();
          //  var test = props.refresh;
          //  props.setRefresh(++test);
          //  alert.success(data.message);
          //refreshPage(data);

          //console.log(data, "noo");
          setCanDelete(true);

        } else {
          //   alert.error(data.message);
          setCanDelete(false);
        }
      })
      .catch((error) => {
        alert.error("Error", error);

      })

  }


  const deletePost = () => {
    setDisable(true);

    var data = {
      pats: encryptData(props.data.patsQuantity),
      UserID: encryptData(props.data.UserID),
      postJSON: props.data.postJSON,
      postID: encryptData(props.data.postID),
    };
    postData(
      process.env.REACT_APP_API_URL + "api/post/delete",
      data
    )
      .then((data) => {
        if (data.issuccessful == true) {
          setDisable(false);
          setDropdown(false);
          $(`.post-${props.data.postID}`).fadeOut();
          setTimeout(() => {
            props.setMonthlyPats(data.pats);
            $(`.post-${props.data.postID}`).remove();
          }, 1000);
        } else {
          setDisable(false);
          setDropdown(false);
          if (data.status == 400) {
            alertify.alert('').setHeader('').setContent(data.message).set('label', 'Okay!').show();
          } else {
            alert.error(data.message);
          }
        }
      })
      .catch((error) => {
        alert.error("Error", error);

      })

    // console.log(props.data);

  }


  //#endregion
  var uid = props.data.UserID;
  return (
    <div className={`pp-item post-${props.data.postID}`}>
      <div className="pp-card">
        <div className="pp-profile-wrap pp-padd">
          <div className="pp-profile">
            <div className="pp-pats">
              <p>+{props.data.patsQuantity}</p>
            </div>
            <div
              className="pp-profile-img bg-img"
              style={{
                backgroundImage: `url(${process.env.REACT_APP_IMG_URL +
                  (props.data.UserImage ? props.data.UserImage : "no-img.png")
                  })`,
              }}
            ></div>

            <div className="pp-profile-name">
              <NavLink
                activeclassName="pp-profile-name-nav"
                style={{ textDecoration: "none", color: "black" }}
                to={"/profile/" + uid}
              >
                {props.data.UserName}
              </NavLink>
            </div>
          </div>
          <div className="pp-date-wrap">
            <p className="pp-date">{props.data.formattedDate}</p>

            <div className="pp-menu" style={{ position: "relative" }}>
              <img
                className="pp-menu-img"
                src={ellipsis}
                alt=""
                onClick={() => { setDropdown(true) }}
              />

              {canDelete &&
                <OutsideClickHandler onOutsideClick={() => { setDropdown(false) }} >
                  {dropDown && props.data.time <= 30 &&
                    <div class="inner-menu-dropdown" style={{
                      position: "absolute",
                      right: "-30px",
                      border: "none",
                      textAlign: "center",
                      zIndex: "9999",
                      backgroundColor: "white",
                      borderRadius: "12px",
                      padding: "10px",
                      marginRight: "5px",
                      boxShadow: "0 10px 10px 0 rgba(0, 0, 0, 0.15)"
                    }}>

                      {props.data.time <= 30 &&
                        <>
                          <button
                            className="dropdown-item-btn"
                            onClick={deletePost}
                            disabled={disable}
                          > <img
                              className="btn-icon"
                              src={deletebtn}
                              alt=""

                            />
                            Delete
                          </button>

                          <hr className="dropdown-hr" />
                        </>
                      }

                      {props.data.time <= 30 &&
                        <>
                          <button className="dropdown-item-btn"
                            onClick={() => history.push("/EditPost/" + props.data.postID)}
                          > <img
                              className="btn-icon"
                              src={edit}
                              alt=""
                              onClick={() => { setDropdown(true) }}
                            />
                            Edit
                          </button>
                        </>
                      }
                      


                    </div>

                  }

                </OutsideClickHandler>

              }



            </div>
          </div>
        </div>
        <div className="pp-post-wrap pp-padd">
          <div className="pp-text-wrap">
            <Editor
              editorKey={"editor" + props.data.postID}
              editorState={editorState}
              onChange={setEditorState}
              readOnly
            />
          </div>
          <div className="pp-badges">
            <div className="pp-slider-wrap">
              <BadgesSlider />

            </div>
          </div>
        </div>
        <div className="pp-likes-wrap pp-padd">
          <div className="pp-controls">
            <PostLike data={props} />
          </div>
          <div className="comment-view-wrap">
            {/* comment display */}
            <CommentView data={allComments} postID={props.data.postID} />
          </div>
          <div className="pp-comment-input">
            {/* <input type="text" className="txt-input" placeholder={"Comment to "+props.data.UserName} onChange={e=>setComments(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && commentSubmit()}/> */}
            {/* <form onSubmit={(e) => commentSubmit(e)}>
              <div className="pp-comment-wrap">
                <textarea
                  className="txt-input txt-comment"
                  rows="3"
                  placeholder="Write a comment..."
                  onChange={(e) => setComments(e.target.value)}
                  value={comments}
                ></textarea>
                
                <button type="submit" className="btn-comment">
                  <img src={arrowRight} alt="" />
                </button>

        
              </div>
              
              <EmojiComment />
             
            </form> */}
            <div>
              <Comment data={props} />
            </div>



            {/* <button type="submit" onSubmit={commentSubmit}> Enter </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostItem;
